import { Component, Input } from '@angular/core';
import { CommonInfoService } from '../../cart-process/common-info.service';
import { IExtendedAdditionalBundleSet } from '../../interfaces/additional-bundles.interface';

@Component({
  selector: 'side-order-details-additional-data',
  templateUrl: './side-order-details-additional-data.component.html',
})
export class SideOrderDetailsAdditionalDataComponent {
  public additionalBundles: IExtendedAdditionalBundleSet;

  @Input() set bundles(bundles: IExtendedAdditionalBundleSet) {
    this.additionalBundles = bundles;
  }

  constructor(
    public commonInfo: CommonInfoService
  ) {

  }
}
